export const sidebarContainerId = 'sidebar-container';
export const subMenuContainerId = 'submenu-container';
